import ServiceVendorRecords from "../../../jsx/components/Dashboard/ServiceVendorRecords/servicevendorrecords";

const ServiceVendorRecordsWrapper = () => {
  return <ServiceVendorRecords />;
};

export default constore(ServiceVendorRecordsWrapper);
